"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'conversations.error.failedToLoad': 'Nie udało się załadować konwersacji',
    'conversations.error.failedToDelete': 'Nie udało się usunąć konwersacji',
    'conversations.error.failedToToggleFavorite': 'Nie udało się zmienić statusu ulubionej',
};
